// test70
(70 && 0);
